import styled          from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

const CardCircularLoader = styled(CircularProgress)`
    display: flex;
    align-self: center;
    margin: 3rem;
`

export default CardCircularLoader